module.exports = __webpack_public_path__ + "img/sq4d_04.0ffd5081.jpg";